import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Icons from '../../Shared/Icons';

import './EndOfStory.scss';

import {startDriving} from '../../../state/actions/timeline';

export class EndOfStory extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    render() {
        return (
            <div className="EndOfStory">
                <div className="EndOfStory__inner">
                    <Icons type="endOfStoryArrow" />
                    <a className="active" onClick={this.backToVideo.bind(this)}>{this.props.backButtonLabel}</a>
                </div>
            </div>
        )
    }

    backToVideo () {
        this.props.startDriving();
        this.context.router.push("/");
    }

}

export default connect(null, {startDriving})(EndOfStory);



// WEBPACK FOOTER //
// ./src/components/DetailPage/EndOfStory/index.js